<p-table
  #dt1
  [value]="playerList"
  dataKey="player_id"
  [rowHover]="true"
  [showGridlines]="false"
  [globalFilterFields]="['name_gt7', 'final_position', 'car_name']"
  responsiveLayout="scroll"
  size="small"
  >
  <ng-template #header let-player>
    <tr>
      <th pSortableColumn="final_position">
        <div class="pi pi-flag flex justify-between items-center">
          <p-sortIcon field="final_position"></p-sortIcon>
        </div>
      </th>
      <th style="min-width: 19rem" pSortableColumn="name_gt7">
        <div class="pi pi-user flex justify-between items-center">
          Fahrer
          <p-sortIcon field="name_gt7"></p-sortIcon>
        </div>
      </th>
      <th style="min-width: 8rem" pSortableColumn="car_name">
        <div class="pi pi-car flex justify-between items-center">
          Auto
          <p-sortIcon field="car_name"></p-sortIcon>
        </div>
      </th>
      <th>
        <div class="pi pi-trophy flex justify-between items-center">
          Ges
        </div>
      </th>
      @for (raceDay of raceDays; track raceDay) {
        <th>
          <div class="pi pi-calendar flex justify-between items-center">
            {{ raceDay.day_real | date: 'dd.MM.yy' }}
          </div>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-player>
    <tr [routerLink]="['/playerDetails', player.player_id]">
      <td>
        {{ player.final_position }}
      </td>
      <td>
        <b>{{ player.name_gt7 }}</b> ({{ player.name_psn }})
      </td>
      <td>
        {{ player.car_name }}
      </td>
      <td>
        <b>{{ player.points_total }}</b>
      </td>
      @for (raceDay of raceDays; track raceDay) {
        <td>
          @if (raceDay.day_planned && hasDayRacePoints(player.player_id, raceDay.day_planned)) {
            <div>
              {{ getDayRacePoints(player.player_id, raceDay.day_planned) }}
            </div>
          }
          @if (raceDay.day_planned && !hasDayRacePoints(player.player_id, raceDay.day_planned)) {
            <div>
              -
            </div>
          }
        </td>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="8">Keine Renndaten vorhanden</td>
    </tr>
  </ng-template>
  <ng-template #loadingbody>
    <tr>
      <td colspan="8">Lade Daten ...</td>
    </tr>
  </ng-template>
</p-table>
